import * as React from "react";
const SvgHelpdeskGrievancesIconConv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 23"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.36 18.359c-2.929 2.929-7.266 3.562-10.815 1.92-.524-.21-.953-.381-1.362-.381-1.137.007-2.553 1.11-3.289.375-.735-.736.368-2.153.368-3.298 0-.408-.163-.83-.374-1.355C.246 12.072.879 7.733 3.808 4.805c3.739-3.74 9.813-3.74 13.552 0 3.746 3.745 3.739 9.814 0 13.554"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.359 11.98h.008M10.517 11.98h.008M6.675 11.98h.008"
    />
  </svg>
);
export default SvgHelpdeskGrievancesIconConv;
